import(/* webpackMode: "eager" */ "/root/viholo-web/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/root/viholo-web/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/root/viholo-web/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["IS_SAFARI","IS_IOS","IS_APPLE_WEBKIT"] */ "/root/viholo-web/node_modules/@payloadcms/richtext-lexical/dist/lexical/utils/environment.js");
;
import(/* webpackMode: "eager" */ "/root/viholo-web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/root/viholo-web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/root/viholo-web/src/app/(frontend)/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/root/viholo-web/src/blocks/Code/Component.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdminBar"] */ "/root/viholo-web/src/components/AdminBar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/viholo-web/src/components/BackToTopBtn/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/viholo-web/src/components/FloatingActions/FloatingContact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/viholo-web/src/components/FontLoader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LivePreviewListener"] */ "/root/viholo-web/src/components/LivePreviewListener/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/root/viholo-web/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/root/viholo-web/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/viholo-web/src/globals/Header/components/desktop/DHeaderSecondRow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/viholo-web/src/globals/Header/components/HeaderLanguageSelector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/viholo-web/src/globals/Header/HeaderMobile.tsx");
